module.exports = __webpack_public_path__ + "static/img/kefu-code.a26eab11.png";